module.exports = __webpack_public_path__ + "MeghaPandichelvam-b12bbd5a.webp";